export default {
  'TITLE_TAB': 'Términos y Condiciones',
  'FORMS_INPUTS': {
    'TERMS': 'Términos y Condiciones',
    'PRIVACY': 'Política de privacidad'
  },
}